import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { trace } from '@opentelemetry/api';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import { isExternalStorageUrl } from './is-external-storage-url';

/**
 * Inject a unique request ID into API requests that can be used to correlate
 * requests on the frontend with requests on the backend.
 *
 * Skips external object storage (S3): the header is useless to S3 and, on the direct
 * upload PUT, forces the bucket CORS to allow-list it or the preflight fails. See DEV-26988.
 **/
export function RequestIdInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (isExternalStorageUrl(req.url)) return next(req);

  const requestId = uuidv4();

  // Tag the request ID in the active span for trace correlation
  const activeSpan = trace.getActiveSpan();
  if (activeSpan) {
    activeSpan.setAttribute('request.id', requestId);
  }

  req = req.clone({
    headers: req.headers.set('x-ninety-request-id', requestId),
  });

  return next(req);
}
